"use strict";
// packages/contracts/src/roteiro.ts — Fase 10, Plano 04 (OPS-11, OPS-12, D-17..D-21).
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=roteiro.js.map